/**
 * @generated SignedSource<<110ea9cacc213ab64f93d14ba9e5a9d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type heroArticlesHomeV2Content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesItemV2Content">;
  readonly " $fragmentType": "heroArticlesHomeV2Content";
};
export type heroArticlesHomeV2Content$key = {
  readonly " $data"?: heroArticlesHomeV2Content$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroArticlesHomeV2Content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "heroArticlesHomeV2Content",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topStoriesItemV2Content"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "fd12e0989c11cbca697d5c66ead2f70b";

export default node;
